import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,ModalController } from 'ionic-angular';
import { DomiciliosappProvider } from '../../providers/domiciliosapp/domiciliosapp'
import { ProductosDescripcionDomiciliosappPage } from '../../pages/productos-descripcion-domiciliosapp/productos-descripcion-domiciliosapp'
import { gruposDomiciliosSearch } from '../../models/gruposDomiciliosSearch'
import { SelectSearchable } from 'ionic-select-searchable';
import { Storage } from '@ionic/storage'
import { PushProvider } from '../../providers/push/push'
import { PushPage } from '../../pages/push/push'
import { CajaProvider } from '../../providers/caja/caja'
import { ComandasProvider } from '../../providers/comandas/comandas'
import { Observable } from 'rxjs/Observable';
import { GruposProductosDomiciliosDescripcionPage } from '../../pages/grupos-productos-domicilios-descripcion/grupos-productos-domicilios-descripcion'
import { Store } from '@ngrx/store';
import * as fromData from '../../store/actions/index'
import { State } from '../../store/app.reducer'
import { CargarGruposSuccessActions,  } from '../../store/actions/index';
import { GestionCaja } from '../../models/gestioncaja.model';
import { DomicilioAppProductosSeleccion } from '../../models/domiciliosappproductosseleccion.model';
import swal from 'sweetalert';

@IonicPage()
@Component({
  selector: 'page-domiciliosapp',
  templateUrl: 'domiciliosapp.html',
})
export class DomiciliosappPage {

  gruposDomicilios:any = []
  gruposVisible:boolean = true
  gruposDomiciliosId
  listagruposDomicilios:gruposDomiciliosSearch[] = []
  listagruposDomicilio:gruposDomiciliosSearch
  buscar: any = "";
  allItems: any;
  public pushcantidad:number=0;
  push:boolean = false
  clienteId = []
  public numeroEnProcceso:number=0
  numeroMostrar:boolean = false
  productosDescripcionDomicilios:any[] = []
  generarcomprarenpage: boolean = false;
  domicilioAppDescripcion: string = ''
  manejaCajaDinamica:boolean = false

  constructor(public navCtrl: NavController, public navParams: NavParams,
             public servicioDomicilios:DomiciliosappProvider,public modalControllers:ModalController,
             public storages:Storage,
             public servicioPush:PushProvider,
             public servicio: CajaProvider,
             public servicioComandas:ComandasProvider,
             private store:Store<State> ) {
              const actions = new fromData.ResetAction(0);

              this.store.dispatch(actions);

              const actionGestionCaja = new fromData.CargarGestionCajaResetActions([])
              this.store.dispatch(actionGestionCaja);
              
              this.store.select('domiciliosappproductosseleccion').subscribe((productosSeleccion)=>{
                console.log('productosSeleccion')
                console.log(productosSeleccion)
              })
              this.buscarDomicilios()

  }


  buscarDomicilios(){
    this.storages.get('companiasId').then((val) => {
      this.servicioDomicilios.buscarDomicilio(val)
      .subscribe((data)=>{

        this.gruposDomicilios = data[0]
        const actions = new CargarGruposSuccessActions(this.gruposDomicilios)

        this.store.dispatch(actions)

      },(error)=>{
        console.log(error)
      })
    })
  }

  ionViewDidLoad() {
    const actionGestionCaja = new fromData.CargarGestionCajaResetActions([])
    this.store.dispatch(actionGestionCaja);
    this.buscarCantidad()
  }

  buscarDomiciliosSeleccionados(item:any){

    let clientesId = 0
    if (this.clienteId && this.clienteId[0] && this.clienteId[0]['value']) {
      // envia el cliente que este seleccionado
      clientesId = this.clienteId[0]['value']
      }
    item['clientesId'] = clientesId
    this.storages.set('clientesId',clientesId)
    this.getMultiple(['usuariosId','companiasId'])
    .then( res => {

        let usuariosId = res['usuariosId']
        let companiasId = res['companiasId']
        item['usuariosId'] = usuariosId
        item['companiasId'] = companiasId

        // let modal = this.modalControllers.create(ProductosDescripcionDomiciliosappPage, { item })
        // modal.present();
        // modal.onDidDismiss(data => {
        //   if (data) {
        //   }
        // })
        this.servicioDomicilios.buscarDomiciliosAddGruposProductosContenido(item['companiasId'])
        .subscribe((data=>{

          this.productosDescripcionDomicilios = data[0]

          const productosSeleccion: DomicilioAppProductosSeleccion[] = [{
            cantidad: data[0].cantidad,
            domiciliosAddGruposProductosContenidoId: data[0].domiciliosAddGruposProductosContenidoId,
            domiciliosAddgruposUuid: data[0].domiciliosAddgruposUuid,
            domiciliosAddproductosUuid: data[0].domiciliosAddproductosUuid,
            imagen: data[0].imagen,
            nombre: data[0].nombre,
            productosId: data[0].productosId,
            valorVenta: data[0].valorVenta,
            valoresAdicionales: data[0].valoresAdicionales
          }]
          
          const actions = new fromData.CargarProductosDomiciliosSuccessActions(productosSeleccion)
          this.store.dispatch(actions)

        }))


  })



  }

  gruposChange(event: { component: SelectSearchable, value: any }) {
    console.log('valor:', event.value);
}

onEvent(event: string, item: any){

  if (event === 'onTextChange') {

    let valor = this.getItems(this.buscar);
    if(valor){
        item = valor
  }
  }
  }

  getItems(event: any): void {
    if(!this.allItems){
      let valores = this.productosDescripcionDomicilios
      this.allItems = valores;
    }

      this.productosDescripcionDomicilios = this.allItems.filter((item) => {
        return item.nombre.toLowerCase().indexOf(this.buscar.toLowerCase()) > -1;
      });
}

buscarPush(){

  // this.storages.get('companiasId').then((val)=>{
  //   if(val){
  //     this.servicioPush.buscar(val).subscribe((data)=>{

  //       if(data[1][0].pushcantidad>0){

  //         this.pushcantidad = data[1][0].pushcantidad
  //       }else{
  //         this.pushcantidad = 0
  //       }
  //     },(error)=>{

  //       console.log(error)
  //     })
  //   }

  // })
}

ionViewWillLoad(){
  this.buscarCantidad()
}

pushMensaje(){
  this.push = !this.push
  let datos = []
  let modal = this.modalControllers.create(PushPage, { datos })
  modal.present();

  modal.onDidDismiss(data => {
   this.buscarPush()
  })
}

BuscarDomiciliosAppComandasVacio(){
   this.getMultiple(['companiasId','usuariosId','clientesId'])
  .then( res => {
      let companiasId = res['companiasId']
      let usuariosId = res['usuariosId']
      let clientesId = res['clientesId']

    this.servicioComandas.GuardarDomiciliosAppComandasVacio(companiasId,usuariosId,clientesId,this.domicilioAppDescripcion)
        // .debounceTime(500)
        .subscribe((data)=>{

          this.numeroMostrar = true

          this.numeroEnProcceso = data[0][0].numero
          const actions = new fromData.IncrementarAction(this.numeroEnProcceso)
          this.store.dispatch( actions )

          this.domicilioAppDescripcion = data[1][0].descripcion
          const gestionCaja: GestionCaja[] = [{
            companiasId,
            codigo: data[0][0].codigo,
            descripcion:this.domicilioAppDescripcion,
            numero: this.numeroEnProcceso,
            usuariosId,
            clientesId
          }]
          const actionGestionCaja = new fromData.CargarGestionCajaSuccessActions(gestionCaja)
          this.store.dispatch(actionGestionCaja);
      },(error)=>{
        console.log(error)
      })
})



}

public requestAutocompleteItems = (text: string): Observable<Response> => {
  // this.buscarComandasGruposPorCompania()
  return  this.servicio.buscarClientesPorCompania(text)
};
  getMultiple(keys: string[]) {
      const promises = [];

      keys.forEach( key => promises.push(this.storages.get(key)) );

      return Promise.all(promises).then( values => {
        const result = {};

        values.map( (value, index) => {
          result[keys[index]] = value;
        });

        return result;
      });
  }

  buscarComandasGruposPorCompania(){
    setTimeout(()=>{
      let clientesId = 0
      if (this.clienteId && this.clienteId[0] && this.clienteId[0]['value']) {
        clientesId = this.clienteId[0]['value']
        }

      this.storages.set('clientesId',clientesId)
      this.getMultiple(['companiasId'])
      .then( res => {
          let companiasId = res['companiasId']
          this.servicioComandas.buscarComandasGruposPorCompania(clientesId,companiasId)
            .debounceTime(500)
            .subscribe((data)=>{

              this.pushcantidad = data[0][0].cantidad
              this.storages.set('pushcantidad',data[0][0].cantidad)
              this.storages.set('codigo',data[0][0].codigo)
          },(error)=>{

            console.log(error)
          })
    })
    },5000)
 }

 buscarCantidad(){
  this.storages.get('pushcantidad').then((val) => {
    if(val){
      this.pushcantidad = val
    }
  })
 }

 buscarproductosDescripcionDomicilios(item:any,index:any){

  let validarPagina =  this.generarcomprarenpage;
    if(validarPagina){
      this.generarcomprarenpage = false;
      return
    }
    this.storages.get('companiasId').then((val)=>{
      if(!val){
    }else {

        this.storages.set('cantidad',item.cantidad)
        if(val!==undefined){
          this.buscarParametrosGenerales(val,item,index)
        }
      }
    })
}

abrirModal(item: any,index:any) {
   if(this.productosDescripcionDomicilios[index].gruposProductosDomiciliosId!=='0'){
      let modal = this.modalControllers.create(GruposProductosDomiciliosDescripcionPage, { item })
      modal.present();
      modal.onDidDismiss(data => {
    })
  }
}

buscarParametrosGenerales(companiasId:any,item:any,index:any) {
  let items = item;
  let indexs = index;
  this.servicioPush.buscarParametrosGenerales(companiasId).subscribe((data)=>{
        this.manejaCajaDinamica = data[0][0].manejaCajaDinamica === 'N' ? false : true;

        if(this.manejaCajaDinamica){
          this.abrirModal(items,indexs)
        }else {
          let tipo: string = 'success'
          let title: string = 'Advertencia!'
          let text:string = 'Debe de cambiar la configuración en Seguridad>Parametros generales, campo: ¿ Maneja caja dinámica ? \n si desea utilizar la caja dinámica'
          let icon:string = 'assets/imgs/parametrocajadinamica.png'
          this.mensaje(title,text,icon)
        }
    },(error)=>{
        console.log(error)
    })
}
mensaje(title:any,text:any,icon:any) {
    swal({title: title,
      text: text,
      icon: icon
  })
}

aumentarUnProducto(item, index) {

  let nuevaCantidad = Number(item['cantidad']) + 1
  
  this.productosDescripcionDomicilios[index]['cantidad'] = nuevaCantidad
  const actions: DomicilioAppProductosSeleccion[] = [{
    cantidad:this.productosDescripcionDomicilios[index]['cantidad'],
    domiciliosAddGruposProductosContenidoId:this.productosDescripcionDomicilios[index]['domiciliosAddGruposProductosContenidoId'],
    domiciliosAddgruposUuid:this.productosDescripcionDomicilios[index]['domiciliosAddgruposUuid'],
    domiciliosAddproductosUuid:this.productosDescripcionDomicilios[index]['domiciliosAddproductosUuid'],
    imagen:this.productosDescripcionDomicilios[index]['imagen'],
    nombre:this.productosDescripcionDomicilios[index]['nombre'],
    productosId:this.productosDescripcionDomicilios[index]['productosId'],
    valorVenta:this.productosDescripcionDomicilios[index]['valorVenta'],
    valoresAdicionales:this.productosDescripcionDomicilios[index]['valoresAdicionales']
  }]
  let domiciliosAddGruposProductosContenidoId = this.productosDescripcionDomicilios[index]['domiciliosAddGruposProductosContenidoId']
  this.store.dispatch(
      new fromData.CargarProductosDomiciliosSeleccionActions(domiciliosAddGruposProductosContenidoId,actions));

  this.generarcomprarenpage = true;
}

disminuirUnProducto(item, index) {
  let nuevaCantidad = Number(item['cantidad']) - 1
  if(nuevaCantidad < 0){
  }else{
      this.productosDescripcionDomicilios[index]['cantidad'] = nuevaCantidad
  }
  this.generarcomprarenpage = true;
}

}



// WEBPACK FOOTER //
// ./src/pages/domiciliosapp/domiciliosapp.ts